<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex
      v-bind="{ [`xs${map.flex}`]: true }"
      v-for = "map in maps"
      :key = 'map.title'
      >
      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs5>
              <div class='title' v-text='map.title'>
              </div>
          </v-flex>
          <v-flex>
            <v-card-media
            :src='map.src'
            height = '100px'
            contain
            >
          </v-card-media>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-btn flat @click.native.stop='openMapDialog(map.mapid)'> Open Map </v-btn>
    </v-card-actions>
  </v-card>
</v-flex>
</v-layout>
<v-dialog
  v-model='dialog'
  scrollable
  transition='dialog-bottom-transition'
  v-bind:hide-overlay='true'
>
  <v-card>
    <v-toolbar class="theme--dark primary">
      <v-btn icon @click.native='closeMapDialog' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{$route.params.id}}</v-toolbar-title>
    </v-toolbar>
    <router-view> </router-view>
  </v-card>
</v-dialog>
</v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'map-selector',
    data () {
      return {
        maps: [
          // {title: 'Valencia Water Conservation', src: '/static/valenciaLogo.png', flex: 4, mapid: 'layer'},
          {title: 'Well Chemistry Map', src: '/static/WaterLevelCard.png', flex: 4, mapid: 'RGWACD'},
          {title: 'Layered Map', src: '/static/WellChemCard.png', flex: 4, mapid: 'mapbox'}
          // {title: 'Well Map 4', src: '/static/mapSelectorImage.jpg', flex: 4}
        ],
        dialog: false
      }
    },
    mounted () {
      if (this.$route.name !== 'MapSelector') {
        this.$nextTick(() => {
          this.dialog = true
        })
      }
    },
    methods: {
      closeMapDialog () {
        this.dialog = false
        this.$router.replace('/project/' + this.$route.params.projectid + '/maps')
      },
      openMapDialog (mapid) {
        if (mapid === 'layer') {
          this.$router.push('/project/' + this.$route.params.projectid + '/maps/layermap/')
        } else if (mapid === 'mapbox') {
          this.$router.push('/project/' + this.$route.params.projectid + '/maps/' + mapid)
        } else {
          this.$router.push('/project/' + this.$route.params.projectid + '/maps/wellmap/' + mapid)
        }
        this.dialog = true
      }
    },
    computed: {
      ...mapGetters('project', {
        project: 'selectedProject'
      }),
      tabComponents () {
        var componentList = []
        for (let componentName in this.project.components) {
          let component = this.project.components[componentName]
          if (component.tab === 'Map') {
          // temporaroly storing lookup key for routing purposes
            component['fbkey'] = componentName
            componentList.push(component)
          }
        }
        return componentList
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/MapSelector.vue